import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAllTransfers = async (filters, page, size) => {
  try {
    const response = await api.get(`/transfer`, {
      headers: setAuthHeader(),
      params: {
        ...filters,
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createTransfer = async (transferData) => {
  try {
    const response = await api.post('/transfer', transferData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao cadastrar dados da transferência.');
  }
};

export const getTransferData = async (transferId) => {
  try {
    const response = await api.get(`/transfer/${transferId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar dados da transferência.');
  }
};

export const updateTransfer = async (transferId, data) => {
  try {
    const response = await api.put(`/transfer/${transferId}`, data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar a transferência.');
  }
};